import React from "react";
import CommonSwal from "../components/Swal/commonSwal";
import { showLoading, hideLoading } from "../store/loadingSlice";
import { useDispatch } from "react-redux";
import Validation from "../helpers/Validation";

const useApi = (apiFunc, showError = true) => {
  const [data, setData] = React.useState();
  const [error, setError] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();

  const request = async (...args) => {
    if (!apiFunc) return;
    setLoading(true);
    try {
      const response = await apiFunc(...args);
      setData(response.data);

      return response.data || response.status;
    } catch (e) {
      const showWarns = process.env.REACT_APP_AMBIENTE !== "production"
      setError(e);
      var mensagemErro;
      if (e?.response) {
        // O pedido foi feito e o servidor respondeu com um código de status que não está na faixa de 2xx
        showWarns && console.warn("Erro de resposta do servidor:", e.response.data);
        showWarns && console.warn("Status do erro:", e.response.status);
        if (e.response.data.message) {
          mensagemErro = e.response.data.message;
          if (Array.isArray(mensagemErro)) {
            let allStrings = mensagemErro.every(
              (item) => typeof item === "string"
            );
            if (allStrings) {
              Validation.validaEmissor(mensagemErro);
            } else {
              mensagemErro = null;
            }
          }
        }
      } else if (e?.request) {
        // O pedido foi feito, mas não recebeu resposta
        showWarns && console.warn("Erro sem resposta do servidor:", e.request);
      } else {
        // Algo aconteceu ao configurar a solicitação que acionou um erro
        showWarns && console.warn("Erro ao configurar a solicitação:", e.message);
      }
      showWarns && console.warn("Configuração da solicitação:", e.config);
      // if (e.response && e.response.status === 500)

      if (showError)
        CommonSwal({
          title: "Oops!",
          text:
            mensagemErro ||
            "Ocorreu algum erro inesperado, se o problema persistir entre em contato com o suporte Orangiuz",
          icon: "error",
        });
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (loading) {
      dispatch(showLoading());
    } else {
      dispatch(hideLoading());
    }
  }, [dispatch, loading]);

  const fetchData = React.useCallback(request, [apiFunc, showError]);

  return { data, error, loading, request: fetchData };
};

export default useApi;
